"use client";

import { useRouter } from "next/navigation";

interface Props {
  evaluationId: string;
}

export function Step5Analysis({ evaluationId }: Props) {
  const router = useRouter();

  return (
    <div className="diag-card" style={{ gap: "16px" }}>
      <div>
        <h3 style={{ margin: 0, fontSize: "15px", fontWeight: 600 }}>Analysis & Report</h3>
        <p style={{ fontSize: "13px", color: "var(--ink-mute)", marginTop: "2px" }}>
          AI-generated insights, corrective action plans and supplier development programme
        </p>
      </div>

      <div style={{
        display: "flex", alignItems: "center", gap: "14px", padding: "16px",
        border: "1px solid var(--line)", borderRadius: "10px", background: "var(--paper-3)",
      }}>
        <span style={{ fontSize: "32px" }}>📊</span>
        <div>
          <p style={{ fontSize: "14px", fontWeight: 600, margin: "0 0 2px" }}>SENSEI Diagnosis</p>
          <p style={{ fontSize: "13px", color: "var(--ink-mute)", margin: 0 }}>
            Full AI analysis with gap assessment, risk review and development programme
          </p>
        </div>
      </div>

      <button
        onClick={() => router.push(`/agentic-workflows/supplier-evaluation/${evaluationId}/analysis`)}
        style={{
          background: "linear-gradient(135deg, var(--indigo), var(--magenta))",
          border: "none", borderRadius: "8px", padding: "10px 16px",
          fontSize: "13px", fontWeight: 600, color: "#fff", cursor: "pointer", width: "100%",
        }}
      >
        View Full Report
      </button>
    </div>
  );
}
